import request from '@/utils/request'

// 新闻信息的分页查询
export function newsPage(data,config) {
  return request({
    url: '/api/news/page',
    method: 'get',
    data,
    config
  })
}


// 新闻信息的修改
export function modNews(data,config) {
  return request({
    url: '/api/news/mod',
    method: 'post',
    data,
    config
  })
}

// 新闻信息的新增
export function addNews(data,config) {
  return request({
    url: '/api/news/add',
    method: 'post',
    data,
    config
  })
}

// 新闻信息的修改
export function detNews(id,config) {
  return request({
    url: '/api/news/det/'+id,
    method: 'get',
    config
  })
}